import React from "react";
import { Lightbulb, AlertTriangle } from "lucide-react";

interface CalloutProps {
  type: "tip" | "warning";
  /**
   * Whether to render the leading icon. Defaults to `true` so existing usages are unaffected.
   */
  showIcon?: boolean;
  children: React.ReactNode;
}

const baseClasses = "callout p-4 rounded-md border flex items-start mb-6";
const typeClasses = {
  tip: "bg-blue-50 border-blue-200 text-blue-800 dark:bg-blue-900/20 dark:border-blue-700 dark:text-blue-100",
  warning:
    "bg-yellow-50 border-yellow-200 text-yellow-800 dark:bg-yellow-900/20 dark:border-yellow-700 dark:text-yellow-100",
};

export const Callout: React.FC<CalloutProps> = ({
  type,
  showIcon = true,
  children,
}) => {
  const Icon = type === "tip" ? Lightbulb : AlertTriangle;
  const iconColorClass =
    type === "tip"
      ? "text-blue-500 dark:text-blue-400"
      : "text-yellow-500 dark:text-yellow-400";

  return (
    <div className={`${baseClasses} ${typeClasses[type]}`}>
      {showIcon && (
        <Icon className={`w-5 h-5 mr-2 ${iconColorClass}`} strokeWidth={2.5} />
      )}
      <div className="flex-1">{children}</div>
    </div>
  );
};
